import { SObject } from '@/types';

export const MASTER_DATA_OBJECTS = [SObject.Product, SObject.Pricebook];

export const CPQ_CONFIGURATION_DATA_OBJECTS = [
  SObject.ProductRule,
  SObject.SummaryVariable,
  SObject.PriceRule,
  SObject.QuoteTemplate,
  SObject.TemplateContent,
  SObject.QuoteTerm,
  SObject.CustomAction,
  SObject.CustomScript,
  SObject.DiscountSchedule,
  SObject.LookupData,
  SObject.ConfigurationAttribute,
  SObject.AttributeSet,
  SObject.DiscountCategory,
];

export const ADVANCED_APPROVALS_CPQ_CONFIGURATION_DATA_OBJECTS = [
  SObject.ApprovalRule,
  SObject.ApprovalVariable,
  SObject.ApprovalChain,
  SObject.Approver,
  SObject.EmailTemplate,
];

export const BILLING_CPQ_CONFIGURATION_DATA_OBJECTS = [
  SObject.GLAccount,
  SObject.GLRule,
  SObject.GLTreatment,
  SObject.LegalEntity,
  SObject.TaxRule,
  SObject.TaxIntegration,
  SObject.TaxTreatment,
  SObject.RevenueDistributionMethod,
  SObject.RevenueRecognitionRule,
  SObject.RevenueRecognitionTreatement,
  SObject.FinanceBook,
  SObject.FinancePeriod,
  SObject.PaymentGateway,
  SObject.PaymentScheduler,
  SObject.BillingRule,
  SObject.BillingTreatment,
  SObject.InvoicePlan,
  SObject.InvoiceScheduler,
];

export const ADVANCED_APPROVALS_OBJECTS_WHICH_REQUIRE_PACKAGE_INSTALLED = {
  [SObject.EmailTemplate]: true,
};

export const BCCPQ_INSTALLER_ID = '04t4N0000004Tm9QAE';
